// extracted by mini-css-extract-plugin
export default {"your-registry":"your-registry--ZkXOH","no-padding-in-desktop":"no-padding-in-desktop--T00Ba","top-level-container":"top-level-container--G2T5E"};